module.exports = __webpack_public_path__ + "static/Case-Studies-AVNT-cd441f69560d6a99293cf21309a5677d.jpeg";